<template>
    <div>
        <div class="text-center col-12" v-show="isLoading">
            <span class="spinner-border" role="status"></span>
        </div>
        <div v-show="!isLoading">
            <div class="mb-3">
                <ClassSelect></ClassSelect>
            </div>
            <Export></Export>
            <LessonHistory></LessonHistory>
        </div>
    </div>
</template>

<script setup>
import { computed, onMounted } from 'vue'
import Store from '../../state/teachingCardStore'

import LessonHistory from '../teachingCard/LessonHistory'
import ClassSelect from '../classSelect/ClassSelect'
import Export from '../teachingCard/Export'

const props = defineProps(['isapp', 'auth'])

const isLoading = computed(() => Store.isLoading())

onMounted(() => {
    const isApp = props.isapp === '1'
    const auth = props.auth
    Store.init(true, isApp, auth)
})
</script>